import moment from 'moment';

const formatSelectedYear = {
  methods: {
    formatSelectedYear(start) {
      const startYear = moment(start).year();
      if (moment(start).dayOfYear() === 1) {
        return `${startYear}`;
      }
      return `${startYear}-${startYear + 1}`;
    },
  },
};

export default formatSelectedYear;



// WEBPACK FOOTER //
// ./src/mixins/formatSelectedYear.js